export interface Quality {
  index: number;
  name: string;
  itemPowerBonus: number;
  baseCraftChance: number;
}

export function createQuality(index: number, name: string, itemPowerBonus: number, baseCraftChance: number): Quality {
  return { index: index, name: name, itemPowerBonus: itemPowerBonus, baseCraftChance: baseCraftChance };
}
